import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Moment from 'moment';
import Datetime from 'react-datetime';
import { formatTimezoneDateTime } from 'helper/unit-helper';
import { Dropdown } from 'components/Dropdown/Dropdown';
import Form from 'components/react-validation/components/form';
import Submit from 'components/react-validation/components/submit';
import Input from 'components/react-validation/components/input';
import Textarea from 'components/react-validation/components/text-area';
import * as Vali from 'helper/validator-helper';
import Translate from 'components/translate';

class AddNewLotModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onSubmit: PropTypes.func,
    onCloseModal: PropTypes.func,
    onFetchProject: PropTypes.func,
    SelectListProject: PropTypes.array,
    onFetchPhase: PropTypes.func,
    SelectListPhase: PropTypes.array,
    onFetchPlan: PropTypes.func,
    onFetchCostCode: PropTypes.func,
    SelectListCostCodes: PropTypes.array,
    SelectListPlan: PropTypes.array,
    ErrorMsg: PropTypes.array,
    SelectListInsurance: PropTypes.array,
    onFetchInsurance: PropTypes.func
  }
  constructor(props) {
    super(props);
    this.state = {
      project: null,
      phase: null,
      plan: null,
      insurance: null,
      costCode: null,
      coe: null
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ErrorMsg.length > 0) {
      this.form.showError(this.refs['name'], nextProps.ErrorMsg[0]);
    }
    if (nextProps.SelectListProject) {
      this.setState({ isLoadingProject: false });
    }
    if (nextProps.SelectListPhase) {
      this.setState({ isLoadingPhase: false });
    }
    if (nextProps.SelectListPlan) {
      this.setState({ isLoadingPlan: false });
    }
    if (nextProps.SelectListInsurance) {
      this.setState({ isLoadingInsurance: false });
    }
    if (nextProps.SelectListCostCodes) {
      this.setState({ isLoadingCostCode: false});
    }
    // console.log(nextProps,'NextProps');
  }

  onChange = (e, type) => {
    this.setState({
      [type]: e.value
    });
  }

  onFetchProject = () => {
    this.setState({
      isLoadingProject: true
    });
    this.props.onFetchProject();
  }

  onFetchPhase = () => {
    this.setState({
      isLoadingPhase: true
    });
    this.props.onFetchPhase(this.state.project.value);
  }

  onFetchPlan = () => {
    this.setState({
      isLoadingPlan: true
    });
    this.props.onFetchPlan(this.state.project.value);
  }

  onFetchInsurance = () => {
    this.setState({
      isLoadingInsurance: true
    });
    this.props.onFetchInsurance();
  }

  onFetchCostCode = () => {
    this.setState({
      isLoadingCostCode: false
    });
    this.props.onFetchCostCode(this.state.project.value);
  }

  onChangeCoe = (coe) => {
    if (typeof (coe) === 'string') {
      this.setState({ coe });
      if (Moment(coe, 'MM/DD/YYYY', true).isValid() || coe === '') {
        this.setState({dateError: null});
      } else {
        this.setState({dateError: 'Invalid datetime.'});
      }
    } else {
      this.setState({ coe: Moment(coe).format('MM/DD/YYYY') });
      if (Moment(coe, 'MM/DD/YYYY', true).isValid() || coe === '') {
        this.setState({dateError: null});
      } else {
        this.setState({dateError: 'Invalid datetime.'});
      }
    }
  }

  resetForm = () => {
    this.setState({
      project: null,
      phase: null,
      plan: null,
      coe: null,
      insurance: null,
      costCode: null
    });
  }

  resetCreateAnother = () => {
    this.form.resetForm(this.refs);
    this.setState({ coe: null});
  }

  closeModal = () => {
    this.props.onCloseModal();
    this.resetForm();
  }

  mapParams = () => {
    const formValues = this.form.getValues();
    const { name, streetAddress, note } = formValues;
    const { project, phase, plan, insurance, coe, costCode} = this.state;
    const params = {
      phaseId: phase.value,
      modelId: plan.value,
      projectId: project.value,
      insurancePolicyId: insurance ? insurance.value : null,
      projectCode: costCode ? costCode.value : null,
      name,
      streetAddress,
      note
    };
    if (coe) {
      params.coe = Moment.isMoment(coe) ? formatTimezoneDateTime(coe) : formatTimezoneDateTime(Moment(coe));
    }

    return params;
  }

  onSubmit = (e) => {
    if (e) { e.preventDefault(); }

    const params = this.mapParams();

    this.props.onSubmit(params, false);
  }

  onSaveAndCreateAnother = (e) => {
    if (e) { e.preventDefault(); }

    const params = this.mapParams();

    this.props.onSubmit(params, true);
  }

  render() {
    const disabled = !this.state.project ||
                     !this.state.phase ||
                     !this.state.plan ||
                     this.state.dateError;
    return (
      <div className=''>
        <Modal show={this.props.isOpen}>
          <Form ref={ref => {this.form = ref;}} onSubmit={this.onSubmit}>
            <Modal.Header style={{padding: '15px 25px'}}>
              <Modal.Title id='contained-modal-title-lg'>Add new <Translate translateKey='lot' capitalize /></Modal.Title>
              <span className='close' onClick={this.closeModal} >&times;</span>
            </Modal.Header>
            <Modal.Body style={{padding: '15px 25px'}}>
              {/* Project dropdown */}
              <div className='form-group'>
                <label htmlFor='project'><Translate translateKey='project' capitalize /> <span className='text-danger'>*</span></label>
                <Dropdown
                  onChange={(e) => this.onChange(e, 'project')}
                  className='filestring-dropdown filter-dropdown'
                  value={this.state.project}
                  onRemote={this.onFetchProject}
                  options={this.props.SelectListProject}
                  optionLabel='text'
                  loading={this.state.isLoadingProject}
                  placeholder='-- Please select'
                  errorMessage='This information is required.'
                  style={{width: '100%'}}
                  ref={ref => {
                    this.project = ref;
                  }} />
              </div>
              {/* Phase dropdown */}
              <div className='form-group'>
                <label htmlFor='phase'><Translate translateKey='phase' capitalize /> <span className='text-danger'>*</span></label>
                <Dropdown
                  onChange={(e) => this.onChange(e, 'phase')}
                  className='filestring-dropdown filter-dropdown'
                  value={this.state.phase}
                  onRemote={this.onFetchPhase}
                  options={this.props.SelectListPhase}
                  optionLabel='text'
                  loading={this.state.isLoadingPhase}
                  disabled={!this.state.project}
                  placeholder='-- Please select'
                  errorMessage='This information is required.'
                  style={{width: '100%'}}
                  ref={ref => {
                    this.phase = ref;
                  }} />
              </div>
              {/* Plan dropdown */}
              <div className='form-group'>
                <label htmlFor='plan'>Plan <span className='text-danger'>*</span></label>
                <Dropdown
                  onChange={(e) => this.onChange(e, 'plan')}
                  className='filestring-dropdown filter-dropdown'
                  value={this.state.plan}
                  onRemote={this.onFetchPlan}
                  options={this.props.SelectListPlan}
                  optionLabel='text'
                  loading={this.state.isLoadingPlan}
                  disabled={!this.state.project}
                  placeholder='-- Please select'
                  errorMessage='This information is required.'
                  style={{width: '100%'}}
                  ref={ref => {
                    this.plan = ref;
                  }} />
              </div>
              {/* Cost code dropdown */}
              <div className='form-group'>
                <label htmlFor='insurance'>Cost center/account</label>
                <Dropdown
                  onChange={(e) => this.onChange(e, 'costCode')}
                  className='filestring-dropdown filter-dropdown'
                  value={this.state.costCode}
                  onRemote={this.onFetchCostCode}
                  options={this.props.SelectListCostCodes}
                  optionLabel='text'
                  // loading={this.state.isLoadingCostCode}
                  disabled={!this.state.project}
                  placeholder='-- Please select'
                  errorMessage='This information is required.'
                  style={{width: '100%'}}
                  ref={ref => {
                    this.costCode = ref;
                  }} />
              </div>
              {/* Insurance dropdown */}
              <div className='form-group'>
                <label htmlFor='insurance'>Insurance policy</label>
                <Dropdown
                  onChange={(e) => this.onChange(e, 'insurance')}
                  className='filestring-dropdown filter-dropdown'
                  value={this.state.insurance}
                  onRemote={this.onFetchInsurance}
                  options={this.props.SelectListInsurance}
                  optionLabel='text'
                  loading={this.state.isLoadingInsurance}
                  placeholder='-- Please select'
                  errorMessage='This information is required.'
                  style={{width: '100%'}}
                  showClear={true}
                  ref={ref => {
                    this.insurance = ref;
                  }} />
              </div>

              {/* Lot number input */}
              <div className='form-group'>
                <label htmlFor='name'><Translate translateKey='lot' capitalize /> number <span className='text-danger'>*</span></label>
                <Input type='text'
                  name='name'
                  ref='name'
                  className='form-control'
                  autoFocus
                  max='100'
                  maxLength='100'
                  validations={[Vali.required, Vali.maxlength]}
                />
              </div>
              {/* Street address input */}
              <div className='form-group'>
                <label htmlFor='streetAddress'>Street address <span className='text-danger'>*</span></label>
                <Input type='text'
                  name='streetAddress'
                  ref='streetAddress'
                  className='form-control'
                  max='200'
                  maxLength='200'
                  validations={[Vali.required, Vali.maxlength]}
                />
              </div>
              {/* COE date */}
              <div className='form-group'>
                <label htmlFor='coe'>COE date</label>
                <Datetime
                  ref={ref => { this.coe = ref; }}
                  inputProps={{ placeholder: 'mm/dd/yyyy' }}
                  timeFormat={false}
                  value={this.state.coe}
                  onChange={coe => this.onChangeCoe(coe)}
                  closeOnSelect={true}  />
                {this.state.dateError &&
                  <span
                    className='text-danger'
                    style={{fontSize: 12, marginTop: 5}}>{this.state.dateError}</span>
                }
              </div>
              {/* Note input */}
              <div className='form-group'>
                <label htmlFor='note'>Note</label>
                <Textarea name='note'
                  ref='note'
                  placeholder='Note'
                  className='form-control'
                  max='200'
                  maxLength='200'
                  validations={[Vali.maxlength]} />
              </div>
            </Modal.Body>
            <Modal.Footer style={{textAlign: 'left', padding: '15px 25px'}} >
              <span className='btn btn-siteone-default' onClick={this.closeModal}>Cancel</span>
              <Submit className='btn btn-primary btn-siteone'
                disabled={disabled}
                style={{marginLeft: 10, marginRight: 5}}>Create</Submit>
              <Submit className='btn btn-primary btn-siteone'
                type='button'
                onClick={this.onSaveAndCreateAnother}
                disabled={disabled}>Save and create another</Submit>
              {/*<CheckBoxSingle
                ref={c => { this.checkBox = c; }}
                style={{display: 'inline-block'}}
                onChecked={() => this.setState({isCreateAnother: !this.state.isCreateAnother})}
                checked={this.state.isCreateAnother}
              label='Create another?' />*/}
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default AddNewLotModal;




// WEBPACK FOOTER //
// ./src/Lots/Components/add-new-lot-modal.js